import ninegrid from "../index.js";

class ngColMoverGrip extends HTMLElement
{
	constructor () {
		super();
		
		this.attachShadow({ mode: 'open' });
	}
	
	connectedCallback() {
		
		this.shadowRoot.innerHTML = `
			<style>
				:host {
					position: absolute;
					border: 1px solid #999;
					background-color: #ccc;
					opacity:0.8;
					cursor: move;
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 1;
				}
			</style>
			
			<span></span>
		`;
	}
}

class ngColMoverIndi extends HTMLElement
{
	constructor () {
		super();
		
		this.attachShadow({ mode: 'open' });
	}
	
	connectedCallback() {
		
		this.shadowRoot.innerHTML = `
			<style>
				:host {
					position: absolute;
					width: 3px;
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 1;
				}
				:host::before {
					content: '';
					display: inline-block;
					position: absolute;
					top: 0;
					width: 0;
					height: 0;
					border-top: 3px solid #666;
					border-left: 3px solid transparent;
					border-right: 3px solid transparent;
				}
				:host::after {
					content: '';
					display: inline-block;
					position: absolute;
					bottom: 0;
					width: 0;
					height: 0;
					border-bottom: 3px solid #666;
					border-left: 3px solid transparent;
					border-right: 3px solid transparent;
				}
				div {
					background-color: #666;
					position: absolute;
					left: 1px;
					width: 1px;
					height: 100%;
				}
			</style>
			
			<div></div>
		`;
	}
}

if (!customElements.get('ng-col-mover-grip')) {
	customElements.define("ng-col-mover-grip", ngColMoverGrip);
}
if (!customElements.get('ng-col-mover-indi')) {
	customElements.define("ng-col-mover-indi", ngColMoverIndi);
}

export class ngColMover
{
	#owner;
	#grip;
	#indi;
	#shiftX;
	#source;
	#ready;
	#prev;
		
	constructor (owner) {

		this.#owner	= owner;

		$(".ng-container", this.#owner.body)
			.append($('<ng-col-mover-grip></ng-col-mover-grip>').hide())
			.append($('<ng-col-mover-indi></ng-col-mover-indi>').hide());
		
		this.#grip		= $("ng-col-mover-grip", this.#owner.body);
		this.#indi		= $("ng-col-mover-indi", this.#owner.body);
		
		this.resetEvent();
	}
	
	resetEvent = () => {

		$(document).off('mouseup', this.#onMouseUp);
		$(".ng-table thead", this.#owner.body).off("mousedown", this.#onPrevMouseDown);
		this.#owner.body.querySelectorAll(".ng-table thead").forEach(el => {
			el.removeEventListener("click", this.#onHeadClick);
		});
		
		$(document).on('mouseup', this.#onMouseUp);
		$(".ng-table thead", this.#owner.body).on("mousedown", this.#onPrevMouseDown);
		
		/**
		 * $(document).on('touchend', this.#onTouchEnd);
		 * 
		$(".ng-table thead", this.#owner.body).on("touchstart", e => {
			if (e.target.tagName == "NG-FILTER-BUTTON") return;
			
			this.#ready = true;
			setTimeout(() => {
				if (this.#ready) this.#onTouchStart(e);
			}, 500);
		}); */
		
		this.#owner.body.querySelectorAll(".ng-table thead").forEach(el => {
			el.addEventListener("click", this.#onHeadClick);
		});
	}

	#onHeadClick = e => {

		if (e.target.closest("ng-filter-button")) return;
		
		const target = e.currentTarget || e.target;
		const before = getComputedStyle(target, ":before");
		const after = getComputedStyle(target, ":after");
		
		if (!before && !after) return;
			
		if (before) {
			const top = Number(before.getPropertyValue("top").slice(0, -2))
			const height = 6;//Number(after.getPropertyValue("height").slice(0, -2))
			const left = Number(before.getPropertyValue("left").slice(0, -2))
			const width = 6;//Number(after.getPropertyValue("width").slice(0, -2))

			if (e.layerX >= left && e.layerX <= left+width && e.layerY >= top && e.layerY <= top+height) {
				var container = e.target.closest(".ng-container-left") || e.target.closest(".ng-container-body");
				if (container) {
					var sourceCell		= container.querySelectorAll("thead tr:nth-child(2) th:not(.dummy),thead tr:nth-child(2) td:not(.dummy)");
					var targetContainer	=  e.target.closest(".ng-container-left") ? this.#owner.body.querySelector(".ng-container-body") : this.#owner.body.querySelector(".ng-container-right");
					var targetCell		= targetContainer.querySelector("thead tr:nth-child(2) th:first-child,thead tr:nth-child(2) td:first-child");

					//const canEvent	= new CustomEvent(ninegrid.EVENT.CAN_FIXED_CHANGE, { bubbles: true, cancelable: true, detail: {} });
					//canEvent.sourceContainer = target;

					//if (!this.#owner.dispatchEvent(canEvent)) return;
					
					const col = parseInt(sourceCell[sourceCell.length-1].dataset.col);
					const colSpan = sourceCell[sourceCell.length-1].colSpan;
					for (var i = 0; i < colSpan; i++) {
						this.#owner.body.querySelectorAll(`[data-col="${col+i}"] ng-col-expand:not(.expand)`).forEach(v => { v.expand(); });
					}
					//this.#owner.body.querySelectorAll("ng-col-expand:not(.expand)").forEach(v => { v.expand(); });
					
					if (e.target.closest(".ng-container-body")) {
						// body 끝 에서 이동시
						if (this.#owner.body.querySelectorAll(".ng-container-right colgroup col:not(.dummy)").length == 0) {
							this.#owner.columns.moveColumn(sourceCell[sourceCell.length-1], targetCell);
						}
						else {
							this.#owner.columns.moveColumn(sourceCell[sourceCell.length-1], targetCell);
							this.#owner.columns.moveColumn(sourceCell[sourceCell.length-1], targetCell);
						}
					}
					else {
						this.#owner.columns.moveColumn(sourceCell[sourceCell.length-1], targetCell);
						this.#owner.columns.moveColumn(sourceCell[sourceCell.length-1], targetCell);
					}
					
					//const doneEvent	= new CustomEvent(ninegrid.EVENT.FIXED_CHANGED, { bubbles: true, cancelable: true, detail: {} });
					//this.#owner.dispatchEvent(doneEvent);
				}
			}
		}
		
		if (after) {
			const top = Number(after.getPropertyValue("top").slice(0, -2))
			const height = 6;//Number(after.getPropertyValue("height").slice(0, -2))
			const left = Number(after.getPropertyValue("left").slice(0, -2))
			const width = 6;//Number(after.getPropertyValue("width").slice(0, -2))

			if (e.layerX >= left && e.layerX <= left+width && e.layerY >= top && e.layerY <= top+height) {
				var container = e.target.closest(".ng-container-body") || e.target.closest(".ng-container-right");
				if (container) {
					var sourceCell = container.querySelector("thead tr:nth-child(2) th:first-child,thead tr:nth-child(2) td:first-child");
					var targetContainer =  e.target.closest(".ng-container-body") ? this.#owner.body.querySelector(".ng-container-left") : this.#owner.body.querySelector(".ng-container-body");
					var targetCell = targetContainer.querySelectorAll("thead tr:nth-child(2) th:not(.dummy),thead tr:nth-child(2) td:not(.dummy)");
					
					const col = parseInt(sourceCell.dataset.col);
					const colSpan = sourceCell.colSpan;
					for (var i = 0; i < colSpan; i++) {
						this.#owner.body.querySelectorAll(`[data-col="${col+i}"] ng-col-expand:not(.expand)`).forEach(v => { v.expand(); });
					}
					//this.#owner.body.querySelectorAll("ng-col-expand:not(.expand)").forEach(v => { v.expand(); });

					if (e.target.closest(".ng-container-right")) {
						this.#owner.columns.moveColumn(sourceCell, targetCell[targetCell.length-1]);
						this.#owner.columns.moveColumn(targetCell[targetCell.length-1], sourceCell);
					}
					else {
						this.#owner.columns.moveColumn(sourceCell, targetCell[targetCell.length-1]);
						this.#owner.columns.moveColumn(sourceCell, targetCell[targetCell.length-1]);
					}
				}
			}
		}
	}
	
	#onTouchStart = e => {
		if (["INPUT"].includes(e.target.tagName)) return;
		
		var rect = e.target.getBoundingClientRect();
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		//e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;

		e.buttons = 1;
		
		this.#onMouseDown(e);
		
		$(document).on("touchmove", e => this.#onTouchMove(e));
	};
	#onTouchMove = e => {
		
		var rect = e.target.getBoundingClientRect();
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		
		this.#onMouseMove(e);
	};
	
	#onTouchEnd = e => {
		e.clientX = e.changedTouches[0].clientX;
		
		this.#onMouseUp(e);
	};
	
	
	#onPrevMouseDown = e => {

		if (ninegrid.j.querySelectorAll(this.#owner).attr("col-movable") != "true") return;
		if (e.target.tagName == "NG-FILTER-BUTTON") return;
		
		this.#ready = true;
		setTimeout(() => {
			if (this.#ready) this.#onMouseDown(e);
		}, 500);
	};
	
	#onMouseDown = e => {

		if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftkey) return;
		//if (!this.ready) return;
		if (["INPUT"].includes(e.target.tagName)) return;
		
		var x = e.pageX - $(e.target).offset().left;

		//if (e.offsetX <= 2) return;
		//if ($(e.target).width() - e.offsetX <= 2) return;
		if (x <= 3) return;
		if ($(e.target).width() - x <= 3) return;



		if (e.target.closest(".ng-container-right")) this.#owner.body.querySelector('ng-hscrollbar').scrollToEnd();

		var td = e.target.closest("th,td");

		//e.preventDefault();
		this.#source = {
			col : parseInt(td.dataset.col),
			row : e.target.closest("tr").sectionRowIndex,
			target : td,//e.target,
			//target : e.target.closest("th,td"),
		}

		//this.#shiftX = e.offsetX + this.#grip[0].getBoundingClientRect().x;
		this.#shiftX = x + this.#grip[0].getBoundingClientRect().x;
		
		//this.#grip.html($(e.target).html());
		const span = this.#grip[0].shadowRoot.querySelector("span");
		span.innerHTML = $(e.target).html();
		
		//this.#grip.css({ "font" : $(td).css("font") });
		$(span).css({ "font" : $(td).css("font") });
		
		this.#grip.show();
		
		//this.#grip.offset({left: $(e.target).offset().left - 1, top: $(e.target).offset().top});
		this.#grip.width($(td).width());
		this.#grip.height($(td).height());
		this.#grip.offset( { top : $(td).offset().top-1 });

		//this.tooltip.show().refresh();

		$(document).on('mousemove', this.#onMouseMove);

		this.#moveAt(e.pageX);
		
		const currentTH = this.#owner.tableUtils.getElement("thead", this.#source.row, e.clientX);
		this.#indi.height($(currentTH).height());
	};
	
	
	
	#onMouseUp = e => {

		this.#ready = false;
		
		$(document).off('mousemove', this.#onMouseMove);
		$(document).off('touchmove', this.#onTouchMove);
		//$(document).off('mouseup', this.#onMouseUp);
	
		if (this.#prev) $(this.#prev.target).css({"cursor" : this.#prev.cursor});

		if (this.#source) {

			var currentTH = this.#owner.tableUtils.getElement("thead", this.#source.row, e.clientX);
			
			this.#owner.columns.moveColumn(this.#source.target, currentTH);
			/**
			if (currentTH) {
				if (this.#source.col > parseInt(currentTH.dataset.col)) {
					this.#owner.tableUtils.moveColumn(this.#source.col, parseInt(currentTH.dataset.col) - 0);
				} else if (this.#source.col < parseInt(currentTH.dataset.col)) {
					this.#owner.tableUtils.moveColumn(this.#source.col, parseInt(currentTH.dataset.col) + 1);
				}
			} */
		}
		
		this.#prev = null;
		this.#source = null;
		
		this.#grip.hide();
		this.#indi.hide();
	};
	
	#onMouseMove = e => {

		if (this.#source == null) return;
		//if (!this.#ready2) return;
		
		if (this.#prev) $(this.#prev.target).css({"cursor" : this.#prev.cursor});
		this.#prev = {target: e.target, cursor : $(e.target).css("cursor"), }
		
		$(e.target).css({"cursor" : e.target.closest("thead") || e.target.tagName == "ng-col-mover-grip" ? "move" : "not-allowed"});
		
		var currentTH = this.#owner.tableUtils.getElement("thead", this.#source.row, e.clientX);
		if (currentTH) {
			if (this.#source.col > parseInt(currentTH.dataset.col)) {
				var offset = $(currentTH).offset();
				
				this.#indi.show();
				//this.#indi.height($(currentTH).height());
				this.#indi.offset({ "left" : parseInt(offset.left - 1), top : offset.top });
			} else if (this.#source.col < parseInt(currentTH.dataset.col)) {
				var offset = $(currentTH).offset();
				
				this.#indi.show();
				//this.#indi.height($(currentTH).height());
				
				this.#indi.offset({ "left" : parseInt(offset.left + $(currentTH).width() - 1), top : offset.top });
			} else {
				this.#indi.hide();
			}
		}

		this.#moveAt(e.pageX);
	}
	
	#moveAt = (pageX) => {
		this.#grip.offset( { left : pageX - this.#shiftX });
	}
}